module.exports = __webpack_public_path__ + "img/tesefuwu_image_zhucan.5857ff94.png";